// extracted by mini-css-extract-plugin
export default {"logoSize":"FooterComponentKit_logoSize__pP5pC"};